import { Loader2, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface SubtaskComposerRowProps {
  title: string;
  onTitleChange: (value: string) => void;
  onAdd: () => void;
  adding?: boolean;
}

/**
 * Linha de composição de subtarefa: apenas o título em largura confortável e
 * um botão de adicionar. A configuração (responsável, data e horário) é feita
 * expandindo a subtarefa após criada.
 */
export function SubtaskComposerRow({
  title,
  onTitleChange,
  onAdd,
  adding = false,
}: SubtaskComposerRowProps) {
  return (
    <div className="flex items-center gap-2">
      <Input
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onAdd();
          }
        }}
        placeholder="Adicionar subtarefa..."
        className="h-10 flex-1"
      />
      <Button
        type="button"
        variant="outline"
        onClick={onAdd}
        disabled={adding || !title.trim()}
        className="h-10 shrink-0"
      >
        {adding ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Plus className="mr-1.5 h-4 w-4" />
        )}
        Adicionar
      </Button>
    </div>
  );
}
